import type { Locale } from '../constants';

export const LANG_ENV = process.env.LANGUAGE_ENV as Locale;
export const IS_DE_LANG_ENV = LANG_ENV === 'de';
export const IS_EN_LANG_ENV = LANG_ENV === 'en';
export const IS_CS_LANG_ENV = LANG_ENV === 'cs';
